import { ODD_FIELD_MAPPING } from 'Store/constants/sportTypes';

const fakeOdd = {
  cht: 0,
  pr: 0,
  imo: false,
  bt: 12,
  ocn: 0,
  mrv: 0,
  mrt: 0,
  mrst: 0,
  hsc: false
}; // içeri basılıcak fake odd

const getScores = cur=> cur[ODD_FIELD_MAPPING.name]?.split('-');

export const generateSpecialOddsWithOrder = newMatchCardOdd => {

  let newOddList = newMatchCardOdd?.oddList?.reduce((acc, cur) => {
    const [homeScore, awayScore] = getScores(cur);

    if (homeScore > awayScore) {
      acc[0].push(cur);
    }
    if (homeScore === awayScore || !awayScore) {
      acc[1].push(cur);
    }
    if (homeScore < awayScore) {
      acc[2].push(cur);
    }

    return acc;
  }, [[], [], []]); // skorlara göre 1-0-2 şeklinde parçalandı


  newOddList = newOddList.map((e, index) => e.sort( // sıralama
    (a, b) => {
      const [aHome, aAway] = getScores(a);
      const [bHome, bAway] = getScores(b);

      if (!aAway) return 1; // "diğer" şeklinde gelen score için
      if (!bAway) return -1; // "diğer" şeklinde gelen score için

      if (index === 2) { // away takımın kazandığı skorlarda önce away takım scorları kontrol ediliyor (0-1 ... 0-6)
        return (+aAway - +bAway) || (+aHome - +bHome);
      }
      return (+aHome - +bHome) || (+aAway - +bAway); //(1-0 ... 6-0)
    }));

  if (!newOddList[1].length) {
    const maxNoDraw = Math.max(newOddList[0].length, newOddList[2].length);
    let noDrawReturnedArray = [];

    for (let index = 0; index < maxNoDraw; index++) {
      if (newOddList[0][index]) noDrawReturnedArray.push(newOddList[0][index]);
      if (newOddList[2][index]) noDrawReturnedArray.push(newOddList[2][index]);
    }

    return noDrawReturnedArray;
  }

  const max = Math.max(...newOddList.map(e=>e.length)); // max length bulundu

  newOddList = newOddList?.map(e => { // length i max olmayan arraylere max a eşit olana kadar fake odd basıldı
    if (e.length < max) {
      const remain = new Array(max - e.length).fill(fakeOdd);
      return e.concat(remain);
    }
    return e;
  });

  let returnedArray = [];

  for (let index = 0; index < max; index++) { // her arrayin 1. elemanlanları 2.elemanları sırayla yeni arrayde toplandı
    for (let i = 0; i < 3; i++) {
      returnedArray.push(newOddList[i][index]);
    }
  }

  return returnedArray;
};


export const isSelfGenerateRequired = (generateRequiredTypes, odd)=>{
  if (generateRequiredTypes?.length) {
    const myType = `${odd?.marketType}-${odd?.marketSubType}`;
    return generateRequiredTypes?.some(t => t === myType) || false;
  }
  return false;
};
